<template>
  <div class="main-page page-service-law">
    <Menus title="法律法规" :home="true" />
    <div class="container-flex">
      <div class="law-list-panel">
        <div class="item" @click="toDetail( item)" v-for="(item, index) in showList" :key="'key-law-sort-' + index" v-if="!item.parentId">
          <div class="title">
            <span>{{ item.name }}</span>
          </div>
          <div class="detail">实施：{{ $moment(item.enforcementDate).format('YYYY-MM-DD HH:mm') }} 丨
            时效性：{{ item.forceStatus }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { getLawlist } from '@/datas/js/law'
export default {
  data () {
    return {
      list: [],
      list1: []
    }
  },
  computed: {
    showList () {
      return [...this.list, ...this.list1].sort((a, b) => b.forceLevelSort - a.forceLevelSort)
    }
  },
  components: { Menus },

  async created () {
    if (!this.$app.appId) {
      await this.$store.dispatch('app/getAppInfoBySite')
    }
    await Promise.all([
      this.fetchData({ areaId: 'EF33ACF4A6D4493691FC1BDA36F98CBD', listKey: 'list1' }),
      this.fetchData({ areaId: '750DD8CD687341249A83E3412D117BCC', listKey: 'list' })
    ])
  },
  methods: {
    async fetchData ({ areaId = null, listKey }) {
      const params = {
        professionalId: this.$route.params.professionalId,
        pageNo: 1,
        pageSize: 1000,
        appId: this.$app.appId,
        forceStatus: 1,
        areaId,
      }

      const { data, response } = await getLawlist(params)
      if (response.success) {
        this[listKey] = data && data.result || []
      }
    },
    toDetail (item) {
      this.$router.push(`/LawDetail/${item.id}?hide_nav=1`)
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-service-law
  .container-flex
    padding 0.3rem 2.6rem 0.5rem 2.6rem
    .law-list-panel
      .item
        padding 0.45rem 0.35rem
        margin-bottom 0.3rem
        background-color #fff
        border-radius 0.08rem
        .title
          font-size 0.3rem
          line-height 0.45rem
          color #666
          margin-bottom 0.2rem
        .detail
          font-size 0.26rem
          color #999
</style>